module.exports = __webpack_public_path__ + "assets/img/error.54d667ab.svg";